// extracted by mini-css-extract-plugin
export default {"loading-spinner":"LoadingSpinner_loading-spinner__yx9Rf","spinner":"LoadingSpinner_spinner__au5x6"};